<template>
  <div class="left-nav blue-background">
    <div class="q-pb-sm progress-bar-border">
      <div class="q-py-sm lt-md">&nbsp;</div>
      <div
        class="quote-number q-ma-sm rounded q-py-sm q-px-lg q-mb-lg gt-sm"
        style="background-color: var(--primary-color-background); color: #616161; text-align: center"
      >
        Quote Number :
        {{ quoteRef }}
      </div>
      <div :class="isUserSecondaryApplicant ? 'numbers-secondary' : 'numbers'">
        <div class="number" v-for="number in numbers" :key="number">
          <div v-if="number < step" class="complete">
            <i class="uiw-font-tick" style="color: var(--primary-color); font-size: 12px" />
            <!-- <img src="/assets/icons/tick.svg" /> -->
          </div>
          <div v-if="number == step" class="active">{{ number }}</div>
          <div v-if="number > step">{{ number }}</div>
          <div class="gt-sm step-item">
            <h4 :class="number == step ? 'active' : ''">
              {{ getStepText(number) }}
            </h4>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="q-pb-lg q-mb-md lt-md text-center">
      <h4>{{ getStepText(step) }}</h4>
    </div>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'ProgressSteps',
  props: {
    step: Number
  },
  data: function () {
    return {
      numbers: []
    };
  },
  mounted() {
    if (!this.isUserSecondaryApplicant) this.numbers = [1, 2, 3, 4];
    else this.numbers = [1, 2];
  },
  computed: {
    ...mapState({
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null
    }),
    ...mapGetters({
      isUserSecondaryApplicant: 'vehicleApplication/isUserSecondaryApplicant'
    }),
    quoteRef() {
      return this.scoreboard?.quoteDetails?.milesQuoteRef || this.scoreboard?.quoteDetails?.erpQuoteRef || '';
    }
  },
  methods: {
    getStepText: function (step) {
      if (!this.isUserSecondaryApplicant)
        switch (step) {
          case 1:
            return 'Review Quote';
          case 2:
            return 'Business Details & Credit Application';
          case 3:
            return 'ID Check & Application Review';
          case 4:
            return 'Review & Sign Lease Documentation';
        }
      else
        switch (step) {
          case 1:
            return 'ID Check';
          case 2:
            return 'Review & Sign Lease Documentation';
        }
    }
  }
};
</script>

<style lang="sass" scoped>
flex
  justify-content: center;
.numbers
  margin: 0 auto;
  @media(max-width: 1023px)
    display: flex;
    width: 200px;
  @media(min-width: 1024px)
    padding: 0 20px;
.numbers-secondary
  margin: 0 auto;
  @media(max-width: 1023px)
    display: flex;
    width: 100px;
  @media(min-width: 1024px)
    padding: 0 20px;
.number
  @media(max-width: 1023px)
    flex: 1;
  position: relative;
  z-index: 1;
  @media(min-width: 1024px)
    clear: both;
.number > div:first-child
  background: $secondary;
  color: white;
  border: 2px solid $secondary;
  padding: 0;
  border-radius: 50%;
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 26px;
  font-size: 12px;
  @media(min-width: 1024px)
    float: left;
    margin-top: 10px;
.number > div.complete
  background-color: $primary-background;
  border: 1px solid $primary-background;
  img
    width: 12px
.number > div.active
  background-color: $primary;
  border: 2px solid $primary;
  color: white;
.number:before
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  right: 0;
  width: 20px;
  height: 1px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  z-index: -1;
  @media(min-width: 1024px)
    border-bottom: 0;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    width: 1px;
    height: 60px;
    left: 14px;
    right: initial;
    top: 20px;
.number:last-child:before
  display: none;
h6
  font-size: 18px;
  line-height: 22px;
  margin-top: -3px;
.step-item
  float: left;
  margin-bottom: 15px;
  max-width: calc(100% - 35px);
.step-item h4
  opacity: 0.65;
  line-height: 18px;
  padding-left: 15px;
  margin-top: 17px;
.step-item sub.active, .step-item h4.active
  opacity: 1;
.quote-number
  background: rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.65)
</style>
